import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LibPageHeaderComponent, LibWarrantyPolicyComponent } from '@web-nx-ng-tsc/web-promo-shared-ui';
import { IPageHeaderEntity, ITermsAndPolicyEntity } from '@web-nx-ng-tsc/web-shared-data-access';
import { IMeta, MetaService } from '@web-nx-ng-tsc/util-meta';

@Component({
  selector: 'app-tirewarranty-policy-180-day',
  imports: [LibPageHeaderComponent, LibWarrantyPolicyComponent],
  templateUrl: './tirewarranty-policy-180-day.component.html',
  styleUrl: './tirewarranty-policy-180-day.component.scss',
})
export class TirewarrantyPolicy180DayComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly metaService = inject(MetaService);

  pageHeaderObj = signal<IPageHeaderEntity>({
    pageTitle: 'นโยบายการรับประกัน 180 วัน',
    pageSubTitle: '(Warranty Policy 180 Day)',
    subTitles: [
      {
        title: 'หน้าแรก',
        partName: '/',
      },
      {
        title: 'นโยบายการรับประกัน 180 วัน (Tirewarranty Policy 180 Day)',
        partName: '/tirewarranty-policy-180-day',
      },
    ],
  });

  warrantyPolicyObj: ITermsAndPolicyEntity[] = [
    {
      title:
        'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด จะรับประกันยางว่าชำรุด 180 วัน เปลี่ยนฟรี สำหรับผลิตภัณฑ์ยางรถยนต์ ภายใต้ยี่ห้อ ADVANCE และ ADVANCE TYRE เฉพาะที่บริษัทนำเข้ามาจากต่างประเทศ ตามข้อกำหนดและเงื่อนไขที่ได้ระบุไว้ในนโยบายการรับประกันนี้เท่านั้น โดยไม่รวมถึงการรับประกันอื่นใดนอกเหนือจากนี้ เช่น ค่าบริการอันเกิดขึ้นจากการถอดใส่ ค่าสูญเสียเวลา ค่าสูญเสียอันเนื่องจากการไม่ได้ใช้รถยนต์ ค่าความไม่สะดวกและผลจากการเสียหายอื่นตามที่กฎหมายอนุญาต',
    },
    {
      title:
        'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด จะมอบสิทธิ์การรับประกันยางชำรุด 180 วัน เปลี่ยนฟรี นับตั้งแต่วันที่ระบุในใบเสร็จรับเงิน เมื่อเปลี่ยนยางรถยนต์ภายใต้ยี่ห้อ ADVANCE และ ADVANCE TYRE ทุกรุ่น ทุกขนาดจำนวน 4 เส้น ต่อรถ 1 คัน ต่อ 1 ใบเสร็จรับเงิน ที่ตัวแทนจำหน่ายยางรถยนต์อย่างเป็นทางการของบริษัทฯ และต้องลงทะเบียนผ่านโปรแกรมที่บริษัทฯ กำหนดโดยข้อมูลถูกต้องและครบถ้วนตามความจริง และจะสิ้นสุดพร้อมอายุการรับประกันภายหลัง 180 วันนับตั้งแต่วันที่ระบุไว้ในใบเสร็จ',
    },
    {
      title:
        'การรับประกันยางชำรุด 180 วันเปลี่ยนฟรี ครอบคลุมยางชำรุดที่เกิดจากการใช้งานตามปกติ หรือเกิดจากกาผลิตที่ไม่สามารถซ่อมแซมให้สามารถใช้งานตามปกติได้ เช่น ยางโดนของมีคมบาด แต่ยางนั้นสามารถปะได้ หรือยางที่แตกระหว่างร่อง แรงเบียดบ่า ยางบิดแต เป็นต้น แต่การรับประกันนี้ไม่ครอบคลุมความเสียหายของกระทะล้อ แม็กซ์หรืออะไหล่เกี่ยวเนื่องอื่นๆ และไม่ครอบคลุมอุบัติเหตุ ความเสียหายต่อชีวิตและทรัพย์สิน รวมถึงการบาดเจ็บของผู้ใช้สินค้าดังกล่าว',
    },
    {
      title:
        'ผลของการพิจารณาให้ชดเชยยางรถยนต์ที่ชำรุดเสียหาย ให้ถือเอาการพิจารณาของผู้แทนที่ได้รับการแต่งตั้งจาก ADVANCE TYRE เป็นที่สิ้นสุด และบริษัทฯ ขอสงวนสิทธิ์ในการเรียกเก็บเงินค่าช่างที่ได้ทำการชดเชยไปแล้วกลับคืน',
    },
    {
      title:
        'การขอรับชดเชยยางในากรรับประกันนี้ ผู้ขอรับประกันจะต้องนำยางที่ชำรุดเสียหายมาแสดงและส่งมอบต่อร้านค้าที่ซื้อยางเพื่อส่งคืนให้ทางบริษัทฯ และต้องแนบใบเสร็จรับเงินพร้อมเอกสาร/หลักฐานการรับประกันฯ เพื่อการตรวจสอบข้อมูลยาง(ยี่ห้อ/รุ่น/ขนาด) และข้อมูลรถ (ยี่ห้อ/รุ่น/ทะเบียนรถ) หากข้อมูลยางชำรุดและเอกสารหลักฐานตามที่ระบุข้างต้นการรับประกันไม่ถูกต้องตรงกัน หรือไม่สามารถตรวจสอบข้อมูลดังกล่าวได้ ทางบริษัทฯ ขอสงวนสิทธิ์ในการยกเลิกการรับประกันฯ',
    },
    {
      title:
        'การเปลี่ยนยางเส้นใหม่เพื่อชดเชยยางที่ชำรุด โดยบริษัทฯจะเปลี่ยนยาง ยี่ห้อ รุ่น และขนาดเดียวกัน กับยางเดิมที่ชำรุด ยกเว้นกรณีไม่มียาง ยี่ห้อ รุ่น และขนาดเดิม ทางบริษัทฯจะชดเชยยาง ยี่ห้อ หรือรุ่นอื่นทดแทน และหากยางที่มาทดเชยมีราคาสูงกว่า ผู้ขอรับประกันจะต้องชำระเงินส่วนต่างที่เกิดขึ้น โดยคิดคำนวณจากราคา ณ วันที่เปลี่ยนยางใหม่ กรณียางชำรุดและมีการเปลี่ยนยางเส้นใหม่ จะการรับประกัน 180 วัน ยังคงนับจากวันที่ในใบเสร็จรับเงิน และบริษัทฯ จะเปลี่ยนยางเส้นใหม่เพื่อชดเชยยางที่ชำรุดให้สูงสุด 4 เส้นต่อ 1 ใบเสร็จรับเงิน ภายในระยะเวลาการรับประกันยางชำรุด 180 วัน',
    },
    {
      title:
        'การเปลี่ยนยางเส้นใหม่ ไม่รวมถึงค่าบริการถอดและใส่ล้อ รวมถึงค่าบริการตั้งศูนย์ถ่วงล้อ และเติมลมยางไนโตรเจน',
    },
    {
      title:
        'ยางชำรุดที่ได้รับการพิจารณาชดเชย จะตกเป็นกรรมสิทธิ์ของ บริษัท อ.สยาม คอมเมอร์เชียล จำกัด และผู้ขอรับประกันจะไม่สามารถเรียกร้องขอรับคืนได้',
    },
    {
      title: 'การรับประกันนี้ ไม่ครอบคลุมในกรณี ดังนี้',
      subtitle: [
        {
          headers:
            'ยางที่ถูกของมีคมบาด ตำและสามารถซ่อมเพื่อใช้งานได้ตามปกติ โดยผู้ใช้จะต้องเป็นผู้รับผิดชอบค่าใช้จ่ายในการปะซ่อมแซม',
        },
        {
          headers: 'ความไม่พึงพอใจในสินค้า เช่น เสียงของยาง ความแข็งกระด้าง หรือนุ่มนวลของยาง',
        },
        {
          headers: ' ขนาดยาง รุ่นยาง ไม่ตรงกับการใช้งานหรือไม่เหมาะสมกับตัวรถ',
        },
        {
          headers:
            'การใช้งานที่ผิดประเภท หรือเพื่อการแข่งขัน ยางที่ถูกล้มล้อ ยางชำรุดเนื่องจากการถอดใส่ หรือการประกอบกระทะล้อ',
        },
        {
          headers:
            'ผู้ซื้อไม่ได้ลงทะเบียนรับสิทธิประโยชน์การรับประกันยางรถยนต์ชำรุด 180 วัน เปลี่ยนฟรี รวมถึงกรณีเอกสารหลักฐานการรับประกันชำรุดหรือสูญหาย',
        },
        {
          headers: 'มีการเปลี่ยนแปลงกรรมสิทธิ์หรือเปลี่ยนการครอบครองจากผู้ซื้อรายเดิม',
        },
      ],
    },
    {
      title:
        'ยางรถยนต์ภายใต้ยี่ห้อ ADVANCE และ ADVANCE TYRE ที่เป็นยางติดตั้งใหม่ (Original Equipment) และ/หรือเป็นยางนำเข้ามาจากต่างประเทศโดยผู้นำเข้ารายอื่นๆที่ไม่ใช่บริษัท ต.สยาม คอมเมอร์เชียล จำกัด จะไม่ได้รับการรับประกันฯ ตามนโยบายฉบับนี้',
    },
    {
      title:
        'กรณียางชำรุดและผู้ขอรับประกันได้เปลี่ยนยางเส้นใหม่และส่งมอบยางชำรุดให้กับร้านค้าแล้ว ร้านค้าจะต้องนำส่งยางที่ชำรุดมาให้ บริษัท อ.สยาม คอมเมอร์เชียล จำกัด พิจารณาตรวจสอบและชดเชยยางเส้นใหม่ให้กับร้านค้าตามเงื่อนไขที่ได้กำหนดไว้ในนโยบายการรับประกันนี้ โดยผู้ขอรับประกันเป็นผู้รับภาระค่าขนส่ง และทางบริษัทฯ จะไม่รับผิดชอบต่อการสูญหาย หรือความเสียหายใดๆ ในระหว่างการขนส่ง',
    },
    {
      title:
        'บริษัทฯ ขอสงวนสิทธิ์ไม่ทำการเปลี่ยนยางเส้นใหม่ให้ ในกรณีที่ทางบริษัทฯ ได้ตรวจสอบยางที่ชำรุดดังกล่าวและพบว่า การชำรุดของยางที่ขอรับประกันเกิดจากความตั้งใจ หรือจงใจจากผู้ใช้งานหรือตัวแทนจำหน่ายให้เกิดความเสียหายดังกล่าว',
    },
    {
      title:
        'ผู้ขอรับประกัน จะต้องลงทะเบียนการรับประกันตามที่บริษัทฯกำหนดโดยระบุข้อมูลให้ครบถ้วนและถูกต้องตามความเป็นจริง มิฉะนั้น การรับประกันจะเป็นโมฆะ และไม่มีผลบังคับใช้',
    },
    {
      title:
        'ทางบริษัทฯ จะดำเนินการตามกฎหมายหากทำการตรวจสอบและพบว่าผู้ขอการรับประกัน และ/หรือร้านค้า และ/หรือตัวแทนจำหน่าย ได้ทำการทุจริตเพื่อให้ทางบริษัทฯ เกิดความเสียหายจากนโยบายการรับประกันดังกล่าว',
    },
    {
      title:
        'บริษัท ต.สยาม คอมเมอร์เชียล จำกัด ขอสงวนสิทธิ์ในการยกเลิกและ/หรือแก้ไขเปลี่ยนแปลงนโยบายการรับประกันทั้งหมดหรือส่วนหนึ่งส่วนใด เพื่อความเหมาะสม โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า',
    },
  ];

  constructor() {
    this.metaService.updateMeta(this.route.snapshot.data as IMeta);
    this.onSetOpenGraphTags();
  }
  redirectTo(url: string) {
    this.router.navigate([`${url}`]);
  }

  onSetOpenGraphTags() {
    this.metaService.updateOpenGraph({
      title: 'นโยบายการรับประกัน 180 วัน | ADVANCE TYRE Thailand',
      description:
        'อ่านนโยบายการรับประกัน 180 วัน ของ ADVANCE TYRE แบบครบถ้วน ครอบคลุมระยะคุ้มครอง เงื่อนไข ข้อยกเว้น เอกสารที่ต้องใช้ และขั้นตอนการยื่นเคลมอย่างถูกต้อง ติดต่อทีมงานเพื่อคำแนะนำเฉพาะเคสได้สะดวก ช่วยให้ใช้สิทธิ์ได้เต็มที่และดำเนินการรวดเร็ว มั่นใจทุกการซื้อยาง | ADVANCE TYRE Thailand',
      image: 'https://tsc-pub-blob.s3.ap-southeast-7.amazonaws.com/2025-08/logo-toyo_result-20250819114158.webp',
    });
  }
}
